const cyanA = {
  cyanA1: "hsla(0, 0%, 0%, 0)",
  cyanA2: "hsla(196, 100%, 50.0%, 0.031)",
  cyanA3: "hsla(192, 98.0%, 50.9%, 0.085)",
  cyanA4: "hsla(194, 99.6%, 51.3%, 0.133)",
  cyanA5: "hsla(192, 99.5%, 51.3%, 0.173)",
  cyanA6: "hsla(193, 99.7%, 50.4%, 0.226)",
  cyanA7: "hsla(192, 100%, 50.0%, 0.310)",
  cyanA8: "hsla(193, 100%, 50.0%, 0.425)",
  cyanA9: "hsla(190, 99.8%, 50.8%, 0.731)",
  cyanA10: "hsla(188, 100%, 50.0%, 0.775)",
  cyanA11: "hsla(186, 100%, 49.9%, 0.824)",
  cyanA12: "hsla(185, 99.8%, 95.1%, 0.978)"
};
export { cyanA };
//# sourceMappingURL=cyanA.mjs.map
